import { createSelector } from 'reselect';

import { formatProjectLabelFromCompanySettings } from '../../projects/projectHelpers';
import { sortByObjProperty } from '../../common/helpers';
import { getIdMap } from '../../helpers/helpers';

// Base selectors
const getCustomers = (state) => Object.values(state.customers.customers || {});
const getProjects = (state) => state.projects.projects || [];
const getSettings = (state) => state.settings.company?.settings || {};

// Memoized sorted customers - computes ONCE when customers change
export const getSortedCustomers = createSelector(
  [getCustomers],
  (customers) => {
    const sorted = [...customers];
    sorted.sort(sortByObjProperty('name'));
    return sorted;
  },
);

// Memoized formatted & sorted projects - computes ONCE when projects/settings change
export const getFormattedAndSortedProjects = createSelector(
  [getProjects, getSettings],
  (projects, settings) => {
    const formatted = projects.map((project) => {
      const { name: projectName, number, ...rest } = project ?? {};
      return {
        label: formatProjectLabelFromCompanySettings({ name: projectName, number, settings }),
        name: projectName,
        number,
        ...rest,
      };
    });
    formatted.sort(sortByObjProperty('label'));
    return formatted;
  },
);

// Memoized project ID map - computes ONCE when projects change
export const getProjectIdMap = createSelector(
  [getProjects],
  (projects) => getIdMap(projects),
);
